"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*@ngInject*/
exports.default = ['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('search', {
            url: '/search',
            template: require('../views/search.html'),
            controller: 'SearchController',
        });
    }];



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/search/config/routes.js
// module id = 471
// module chunks = 0